// Import packages
import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch } from "antd";

//import styles
import '../../assets/styles/containerStyles/page-add-edit.scss';

// Import components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import MediaSelectorModal from "../../components/media/MediaSelectorModal";
import { InputGroup } from "../../components/uiElements/inputGroup";
import { LinkButton } from "../../components/buttons/buttons";
import { LanguageTabs } from "../../components/uiElements/Tabs";
import { MediaFileCard } from "../../components/media/MediaFileCard";

// Import utils
import {
    changeStateField,
    getInputValues,
    getPatchReqData,
    getTranslatableInputValues,
    getTranslationData,
    initTranslations,
    toggleStateField
} from "../../utils/helperFunctions";
import { mapStateToProps } from "../../redux/mapStateToProps";
import { GetAboutData, UpdateAboutData } from "../../redux/actions";
import { validateTranslations } from "../../utils/validateTranslations";
import { ACCEPT_IMAGE_TYPES } from "../../constants/acceptedTypes";

class About extends Component {
    constructor (props) {
        super(props);
        this.translationsFields = [
            'title',
            'description',
            'subTitle',
            'subDescription',
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields, props.activeLanguages),
                mediaMain: undefined,
                secondaryMedia: undefined,
            },
            isEditing: true,
            errors: {},
            errorsTabs: [],
            languageTab: props.mainLanguage,
            requestLoading: false,
        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.toggleMediaModal = toggleStateField.bind(this, 'mediaModalOpen');
        this.toggleMediaMobileModal = toggleStateField.bind(this, 'mediaMobileModalOpen');
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getTranslationValues = getTranslatableInputValues.bind(this);
        this.getMedia = this.getMedia.bind(this);
        this.getMediaMobile = this.getMediaMobile.bind(this);
        this.deleteMedia = this.deleteMedia.bind(this);
        this.addEditAbout = this.addEditAbout.bind(this);

    }

    async componentDidMount () {
        await this.props.GetAboutData(this.props.id)
        const { aboutData } = this.props;
        const { fieldsData } = this.state;

        const translationsData = {};
        const editingData = aboutData
        if (editingData) {
            Object.keys(fieldsData.translations).forEach(key => {
                const trItem = editingData?.translations?.find(item => item.language === key);
                translationsData[key] = {
                    ...fieldsData.translations[key],
                    title: trItem?.title || '',
                    description: trItem?.description || '',
                    subTitle: trItem?.subTitle || '',
                    subDescription: trItem?.subDescription || '',
                };
            });
        }
        const initStateData = {
            translations: translationsData,
            mediaMain: editingData?.mediaMain,
            secondaryMedia: editingData?.secondaryMedia,
        }
        this.currentData = JSON.parse(JSON.stringify(initStateData));
        this.setState({
            fieldsData: initStateData,
        });

    }

    getMedia (mediaArray) {
        const { fieldsData, errors } = this.state;

        this.currentData?.mediaMain?.id !== mediaArray[0]?.id
            ? this.updatedDataMap.set("mediaMain", mediaArray[0]?.id)
            : this.updatedDataMap.delete("mediaMain");

        this.setState({
            fieldsData: {
                ...fieldsData,
                mediaMain: mediaArray[0],
            },
            errors: {
                ...errors,
                mediaMain: false
            }
        })
    }

    getMediaMobile (mediaArray) {
        const { fieldsData, errors } = this.state;

        this.currentData?.secondaryMedia?.id !== mediaArray[0]?.id
            ? this.updatedDataMap.set("secondaryMedia", mediaArray[0]?.id)
            : this.updatedDataMap.delete("secondaryMedia");

        this.setState({
            fieldsData: {
                ...fieldsData,
                secondaryMedia: mediaArray[0],
            },
            errors: {
                ...errors,
                secondaryMedia: false
            }
        })
    }

    deleteMedia (type) {
        const { fieldsData, } = this.state;

        this.currentData?.[type] ?
            this.updatedDataMap.set(type, null) :
            this.updatedDataMap.delete(type);
        this.setState({
            fieldsData: {
                ...fieldsData,
                [type]: null
            }
        })
    }

    async addEditAbout () {
        await this.setState({
            requestLoading: true
        });
        const { translations, mediaMain, secondaryMedia, } = this.state.fieldsData;
        const translationRequiredFields = ['title', 'description']
        const validationTr = validateTranslations(translations, translationRequiredFields)
        let result = validationTr.result;
        const errors = { ...validationTr.errors };

        if (!mediaMain) {
            errors.mediaMain = true;
            result = false;
        }
        if (!secondaryMedia) {
            errors.secondaryMedia = true;
            result = false;
        }
        if (result) {
            const trData = getTranslationData(translations);
            const reqData = this.getPatchReqData(trData);
            // console.log('reqData', reqData)
            this.props.UpdateAboutData(reqData)
                .finally(() => {
                    this.setState({ requestLoading: false });
                });

        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }

    render () {
        const {
            fieldsData,
            errors,
            languageTab,
            mediaModalOpen,
            mediaMobileModalOpen,
            requestLoading,
            errorsTabs
        } = this.state;
        const initData = this.currentData?.translations[languageTab] || {};
        const currentData = fieldsData.translations[languageTab] || {};

        return <PageWrapper pageTitle={'Մեր մասին'}>
            <section className="page-add-edit about">
                <div className={"images-wrapper"}>
                    <div>
                        <div className="top-side">
                            <label>Նկար <span className={'required-badge'}>*</span></label>
                            <LinkButton title="Ընտրել մեդիադարանից"
                                        className={`media-select-btn ${errors.mediaMain ? 'media-select-error' : ''}`}
                                        cb={this.toggleMediaModal}
                            />
                        </div>
                        {fieldsData?.mediaMain && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.mediaMain}
                                           customDelete={() => this.deleteMedia("mediaMain")}
                            />
                        </div>}
                    </div>
                    <div>
                        <div className="top-side">
                            <label>Փոքր Նկար <span className={'required-badge'}>*</span></label>
                            <LinkButton title="Ընտրել մեդիադարանից"
                                        className={`media-select-btn ${errors.secondaryMedia ? 'media-select-error' : ''}`}
                                        cb={this.toggleMediaMobileModal}
                            />
                        </div>
                        {fieldsData?.secondaryMedia && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.secondaryMedia}
                                           customDelete={() => this.deleteMedia("secondaryMedia")}
                            />
                        </div>}
                    </div>
                </div>

                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>
                <div>
                    <InputGroup inputType="input"
                                type="text"
                                label="Անվանում"
                                placeholder="Անվանում"
                                name="title"
                                value={currentData.title}
                                initValue={initData.title}
                                error={errors['title' + languageTab]}
                                required={true}
                                onChange={this.getTranslationValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Նկարագրություն"
                                placeholder="Նկարագրություն"
                                name="description"
                                value={currentData.description}
                                initValue={initData.description}
                                error={errors['description' + languageTab]}
                                required={true}
                                onChange={this.getTranslationValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Վերնագիր"
                                placeholder="Վերնագիր"
                                name="subTitle"
                                value={currentData.subTitle}
                                initValue={initData.subTitle}
                                error={errors['subTitle' + languageTab]}
                                onChange={this.getTranslationValues}/>
                    <InputGroup inputType="textarea"
                                type="text"
                                label="Ենթավերնագիր"
                                placeholder="Ենթավերնագիր"
                                name="subDescription"
                                value={currentData.subDescription}
                                initValue={initData.subDescription}
                                error={errors['subDescription' + languageTab]}
                                onChange={this.getTranslationValues}/>
                </div>

                <div className="flex-wrapper-right">
                    <LinkButton title={'Փոփոխել'}
                                loading={requestLoading}
                                disabled={!this.updatedDataMap.size}
                                cb={this.addEditAbout}/>
                </div>

            </section>
            <MediaSelectorModal
                isOpen={!!mediaModalOpen}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                getMedia={this.getMedia}
                closeModal={this.toggleMediaModal}
            />
            <MediaSelectorModal
                isOpen={!!mediaMobileModalOpen}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                getMedia={this.getMediaMobile}
                closeModal={this.toggleMediaMobileModal}/>
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetAboutData,
    UpdateAboutData,
};

export default connect(mapStateToProps, mapDispatchToProps)(About)
